
/***************** Website Sliders ******************/
var $sectorsSlider,$sectorsThumbSlider,$sectorsImageSlider;

function initSectorSlider() {
  if ($('.sectors-slider').length) {
    var parentHeight = $('.sectors-slider').closest('.panel').height();
    var slideHeight = parentHeight * 0.7;
    $('.sectors-slider').css('height', slideHeight + 'px');
    isDraggable = true;
    if (Foundation.MediaQuery.atLeast('mediumx')) {
      isDraggable = false;
    }
    $sectorsSlider = $('.sectors-slider').flickity({
      pageDots: false,
      wrapAround: true,
      percentPosition: false,
      rightToLeft: true,
      draggable: isDraggable,
      setGallerySize: false
    });
  }
}

function initSectorThumbSlider() {
  if ($('.sectors-thumb-slider').length) {
    var parentHeight = $('.sectors-thumb-slider').closest('.panel').height();
    var slideHeight = parentHeight * 0.3;
    console.log('initSectorThumbSlider: ' + slideHeight);
    $('.sectors-thumb-slider').css('height', slideHeight + 'px');
    $sectorsThumbSlider = $('.sectors-thumb-slider').flickity({
      asNavFor: '.sectors-slider',
      cellAlign: 'left',
      pageDots: false,
      prevNextButtons: false,
      wrapAround: true,
      draggable: false,
      //rightToLeft: true,
      setGallerySize: false
    });
  }
}

function initSectorImagesSlider() {
  if ($('.sectors-image-slider').length && Foundation.MediaQuery.atLeast('mediumx')) {
    var parentHeight = $('.sectors-image-slider').closest('.panel').height();
    $('.sectors-image-slider').css('height', parentHeight + 'px');
    $sectorsImageSlider = $('.sectors-image-slider').flickity({
      contain: true,
      pageDots: false,
      prevNextButtons: false,
      wrapAround: true,
      rightToLeft: true,
      draggable: false,
      selectedAttraction: 0.015,
      friction: 0.28,
      setGallerySize: false
    });
  }
}

function initHeaderlider() {
  if ($('.header-slider').length) {
    $headerSlider = $('.header-slider').flickity({
      contain: true,
      autoPlay: 4000, // {Number}
      pageDots: false,
      prevNextButtons: true,
      wrapAround: true,
      draggable: true,
      selectedAttraction: 0.015,
      friction: 0.28,
      setGallerySize: false
    });
  }
}

jQuery(document).ready(function($){
  setTimeout( function() {
    initSectorImagesSlider();
    initSectorSlider();
    initSectorThumbSlider();
    initHeaderlider();
    if ($('.sectors-image-slider').length) {
      $sectorsSlider.on( 'select.flickity', function() {
        if (Foundation.MediaQuery.atLeast('mediumx')) {
          setTimeout( function() {
            $sectorsImageSlider.flickity('next');
          }, 280);  // Add delay of 300ms before getting and setting to allow for header change to finish
        }
      });
    }
  }, 150);


});
